(() => {
  const ROOT_SELECTOR = '[data-hr-list1-campaign-buybox]';
  const FLAVORS = [
    { key: 'B', name: 'Berry Whip' },
    { key: 'S', name: 'Strawberry Shortcake' },
    { key: 'P', name: 'Peach Cobbler' }
  ];
  const SKU_FLAVOR_KEYS = { BER: 'B', STR: 'S', PEA: 'P' };
  const DEFAULT_MIXES = {
    1: { B: 0, S: 0, P: 1 },
    2: { B: 1, S: 0, P: 1 },
    3: { B: 1, S: 1, P: 1 }
  };
  const EXPECTED_MIXES = {
    1: ['B', 'S', 'P'],
    2: ['BB', 'BS', 'BP', 'SS', 'SP', 'PP'],
    3: ['BBB', 'BBS', 'BBP', 'BSS', 'BSP', 'BPP', 'SSS', 'SSP', 'SPP', 'PPP']
  };
  const CHECKOUT_TOTALS_CENTS = { 1: 9999, 2: 18999, 3: 26999 };
  const CART_PRICE_VERIFICATION_ERROR = 'The offer price could not be verified.';
  const CART_CONFIRMATION_DELAYS_MS = [250, 500];
  const SAVINGS_DOLLARS = { 1: 20, 2: 50, 3: 90, 4: 120, 5: 150, 6: 180 };
  const THREE_PLUS_MINIMUM = 3;
  const THREE_PLUS_MAXIMUM = 6;
  const ADD_ON_PRICE_CENTS = 8999;
  const COMPARE_PRICE_PER_BOTTLE_CENTS = 12000;
  const THC_PER_BOTTLE_MG = 1270;
  const CART_DRAWER_SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];

  const parseConfig = (root) => {
    const node = root.querySelector('[data-hr-list1-campaign-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('High Rider: invalid List1 campaign buybox configuration.', error);
      return null;
    }
  };

  const initializeReviewCount = (root) => {
    const target = root.querySelector('[data-hr-list1-review-count]');
    if (!target) return;

    let sourceObserver = null;
    const syncFromSource = () => {
      const source = document.querySelector(
        '.jdgm-preview-badge .jdgm-prev-badge[data-number-of-reviews], #judgeme_product_reviews .jdgm-rev-widg[data-number-of-reviews]'
      );
      const count = Number(source?.dataset.numberOfReviews || 0);
      if (!source || !Number.isFinite(count) || count < 1) return false;

      target.textContent = count.toLocaleString('en-US');
      if (!sourceObserver) {
        sourceObserver = new MutationObserver(syncFromSource);
        sourceObserver.observe(source, { attributes: true, attributeFilter: ['data-number-of-reviews'] });
      }
      return true;
    };

    if (syncFromSource()) return;
    const discoveryObserver = new MutationObserver(() => {
      if (!syncFromSource()) return;
      discoveryObserver.disconnect();
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => discoveryObserver.disconnect(), 15000);
  };

  const initializeGallery = (root, config) => {
    const gallery = root.querySelector('[data-hr-campaign-gallery]');
    const mainImage = gallery?.querySelector('[data-hr-gallery-main]');
    const previous = gallery?.querySelector('[data-hr-gallery-previous]');
    const next = gallery?.querySelector('[data-hr-gallery-next]');
    const status = gallery?.querySelector('[data-hr-gallery-status]');
    const thumbnailRail = gallery?.querySelector('[data-hr-gallery-thumbnails]');
    const thumbnails = [...(gallery?.querySelectorAll('[data-hr-gallery-thumbnail]') || [])];
    const media = Array.isArray(config.gallery) ? config.gallery.filter((item) => item?.src) : [];
    if (!gallery || !mainImage || !previous || !next || !thumbnailRail || !media.length) return;

    let index = 0;
    let pointerStartX = null;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    const scrollThumbnailIntoView = (thumbnail) => {
      if (!thumbnail) return;
      const railLeft = thumbnailRail.scrollLeft;
      const railRight = railLeft + thumbnailRail.clientWidth;
      const itemLeft = thumbnail.offsetLeft;
      const itemRight = itemLeft + thumbnail.offsetWidth;
      if (itemLeft >= railLeft && itemRight <= railRight) return;

      thumbnailRail.scrollTo({
        left: Math.max(0, itemLeft - (thumbnailRail.clientWidth - thumbnail.offsetWidth) / 2),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    };

    const show = (nextIndex, shouldFocus = false) => {
      index = (Number(nextIndex) + media.length) % media.length;
      const selectedMedia = media[index];
      const activeThumbnail = thumbnails[index];

      mainImage.classList.add('is-changing');
      mainImage.src = selectedMedia.src;
      mainImage.alt = selectedMedia.alt || `High Rider Spirit product image ${index + 1}`;
      if (mainImage.complete) requestAnimationFrame(() => mainImage.classList.remove('is-changing'));

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
      });
      if (status) status.textContent = `Image ${index + 1} of ${media.length}`;
      scrollThumbnailIntoView(activeThumbnail);
      if (shouldFocus) activeThumbnail?.focus({ preventScroll: true });

      const followingMedia = media[(index + 1) % media.length];
      if (followingMedia?.src) {
        const preload = new Image();
        preload.src = followingMedia.src;
      }
    };

    mainImage.addEventListener('load', () => mainImage.classList.remove('is-changing'));
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    thumbnails.forEach((thumbnail, thumbnailIndex) => {
      thumbnail.addEventListener('click', () => show(thumbnailIndex));
    });

    gallery.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') show(0, true);
      else if (event.key === 'End') show(media.length - 1, true);
      else show(index + (event.key === 'ArrowLeft' ? -1 : 1), true);
    });

    gallery.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' || event.target.closest('button')) return;
      pointerStartX = event.clientX;
    }, { passive: true });
    gallery.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 40) return;
      show(index + (distance < 0 ? 1 : -1));
    }, { passive: true });
    gallery.addEventListener('pointercancel', () => { pointerStartX = null; }, { passive: true });

    show(0);
  };

  const initializeCommerce = (root, config) => {
    const form = root.querySelector('[data-hr-campaign-form]');
    const offers = [...root.querySelectorAll('[data-hr-campaign-offer]')];
    const mixPanel = root.querySelector('[data-hr-spirit-mix-match]');
    const variantInput = root.querySelector('[data-hr-campaign-variant-input]');
    const atc = root.querySelector('[data-hr-campaign-atc]');
    const atcLabel = root.querySelector('[data-hr-atc-label]');
    const atcLoading = root.querySelector('[data-hr-atc-loading]');
    const errorOutput = root.querySelector('[data-hr-campaign-error]');
    const packPreview = mixPanel?.querySelector('[data-hr-pack-preview]');
    const packBottles = mixPanel?.querySelector('[data-hr-pack-bottles]');
    const packSummary = mixPanel?.querySelector('[data-hr-pack-summary]');
    const mixMessage = mixPanel?.querySelector('[data-hr-mix-message]');
    if (!form || offers.length !== 3 || !mixPanel || !variantInput || !atc || !atcLabel || !config.variants?.length) return;

    const flavorOrder = Object.fromEntries(FLAVORS.map((flavor, flavorIndex) => [flavor.key, flavorIndex]));
    const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
    const unavailableFlavorKeys = new Set(
      String(mixPanel.dataset.hrUnavailableFlavors || '')
        .split(',')
        .map((key) => key.trim().toUpperCase())
        .filter((key) => hasOwn(flavorOrder, key))
    );
    const flavorIsUnavailable = (flavorKey) => unavailableFlavorKeys.has(flavorKey);
    const selectedMixes = Object.fromEntries(
      Object.entries(DEFAULT_MIXES).map(([pack, counts]) => [pack, { ...counts }])
    );
    Object.values(selectedMixes).forEach((counts) => {
      let displaced = 0;
      FLAVORS.forEach((flavor) => {
        if (!flavorIsUnavailable(flavor.key)) return;
        displaced += Number(counts[flavor.key] || 0);
        counts[flavor.key] = 0;
      });
      if (!displaced) return;
      const fallback = FLAVORS.find((flavor) => (
        flavor.key === 'P' && !flavorIsUnavailable(flavor.key)
      )) || FLAVORS.find((flavor) => (
        !flavorIsUnavailable(flavor.key) && Number(counts[flavor.key] || 0) > 0
      )) || FLAVORS.find((flavor) => !flavorIsUnavailable(flavor.key));
      if (fallback) counts[fallback.key] = Number(counts[fallback.key] || 0) + displaced;
    });
    const bottleAssets = {
      B: { src: packPreview?.dataset.hrBerryBottleSrc || '', width: 237, height: 600 },
      S: { src: packPreview?.dataset.hrStrawberryBottleSrc || '', width: 237, height: 600 },
      P: { src: packPreview?.dataset.hrPeachBottleSrc || '', width: 237, height: 600 }
    };
    const variantsByMix = new Map();
    const addOnVariantsByFlavor = new Map();
    let selectedPack = 3;
    let busy = false;
    let cartError = '';
    let lastPreviewSignature = '';

    const canonicalMix = (mix) => [...String(mix || '').toUpperCase()]
      .filter((key) => hasOwn(flavorOrder, key))
      .sort((left, right) => flavorOrder[left] - flavorOrder[right])
      .join('');
    const baseVariantKey = (variant) => {
      const sku = String(variant.sku || '').trim().toUpperCase();
      const legacyMatch = sku.match(/-(1|2|3)-([BSP]+)$/);
      const currentMatch = sku.match(/-((?:BER|STR|PEA)(?:-(?:BER|STR|PEA)){0,2})-([123])$/);
      if (!legacyMatch && !currentMatch) return null;
      const pack = Number(legacyMatch?.[1] || currentMatch[2]);
      const mix = canonicalMix(legacyMatch
        ? legacyMatch[2]
        : currentMatch[1].split('-').map((token) => SKU_FLAVOR_KEYS[token]).join(''));
      return mix.length === pack ? `${pack}:${mix}` : null;
    };
    const addOnFlavorKey = (variant) => {
      const sku = String(variant.sku || '').trim().toUpperCase();
      const legacyMatch = sku.match(/-ADD-([BSP])$/);
      if (legacyMatch && hasOwn(flavorOrder, legacyMatch[1])) return legacyMatch[1];
      const currentMatch = sku.match(/-(BER|STR|PEA)-ADD$/);
      return currentMatch ? SKU_FLAVOR_KEYS[currentMatch[1]] : null;
    };

    config.variants.forEach((variant) => {
      const baseKey = baseVariantKey(variant);
      if (baseKey && !variantsByMix.has(baseKey)) variantsByMix.set(baseKey, variant);
      else if (baseKey) console.warn(`High Rider: duplicate Spirit variant mix ${baseKey}.`);

      const addOnKey = addOnFlavorKey(variant);
      if (addOnKey && !addOnVariantsByFlavor.has(addOnKey)) addOnVariantsByFlavor.set(addOnKey, variant);
      else if (addOnKey) console.warn(`High Rider: duplicate additional-bottle variant ${addOnKey}.`);
    });

    const missingBaseKeys = Object.entries(EXPECTED_MIXES).flatMap(([pack, mixes]) => (
      mixes.filter((mix) => !variantsByMix.has(`${pack}:${mix}`)).map((mix) => `${pack}:${mix}`)
    ));
    const missingAddOnKeys = FLAVORS
      .map((flavor) => flavor.key)
      .filter((key) => !addOnVariantsByFlavor.has(key));
    const invalidAddOnPriceKeys = FLAVORS
      .map((flavor) => flavor.key)
      .filter((key) => {
        const variant = addOnVariantsByFlavor.get(key);
        return variant && Number(variant.price) !== ADD_ON_PRICE_CENTS;
      });
    const variantMapComplete = missingBaseKeys.length === 0;
    const addOnMapComplete = missingAddOnKeys.length === 0 && invalidAddOnPriceKeys.length === 0;

    if (!variantMapComplete) {
      root.dataset.hrVariantMapError = missingBaseKeys.join(',');
      console.error(`High Rider: missing Spirit variants: ${missingBaseKeys.join(', ')}.`);
    }
    if (!addOnMapComplete) {
      root.dataset.hrAddOnVariantError = [
        ...missingAddOnKeys.map((key) => `missing:${key}`),
        ...invalidAddOnPriceKeys.map((key) => `price:${key}`)
      ].join(',');
      console.error(`High Rider: invalid Spirit add-ons: ${root.dataset.hrAddOnVariantError}.`);
    }

    const selectedCounts = () => selectedMixes[selectedPack];
    const selectedTotal = (counts = selectedCounts()) => FLAVORS.reduce(
      (total, flavor) => total + Number(counts?.[flavor.key] || 0),
      0
    );
    const limits = (pack = selectedPack) => ({
      minimum: pack,
      maximum: pack === 3 ? THREE_PLUS_MAXIMUM : pack
    });
    const mixForCounts = (counts) => FLAVORS.map(
      (flavor) => flavor.key.repeat(Number(counts?.[flavor.key] || 0))
    ).join('');
    const replacementFlavor = (counts, targetKey) => FLAVORS
      .filter((flavor) => (
        !flavorIsUnavailable(flavor.key) &&
        flavor.key !== targetKey &&
        Number(counts?.[flavor.key] || 0) > 0
      ))
      .sort((left, right) => {
        const quantityDifference = Number(counts[right.key] || 0) - Number(counts[left.key] || 0);
        return quantityDifference || flavorOrder[right.key] - flavorOrder[left.key];
      })[0] || null;

    const baseCountsForSelection = (counts, pack = selectedPack) => {
      if (pack !== 3) return { ...counts };

      const baseCounts = Object.fromEntries(FLAVORS.map((flavor) => [flavor.key, 0]));
      let remaining = THREE_PLUS_MINIMUM;
      FLAVORS.forEach((flavor) => {
        const quantity = Math.max(0, Number(counts?.[flavor.key] || 0));
        if (!quantity || !remaining) return;
        baseCounts[flavor.key] = 1;
        remaining -= 1;
      });

      while (remaining > 0) {
        const nextFlavor = FLAVORS
          .filter((flavor) => Number(counts?.[flavor.key] || 0) > baseCounts[flavor.key])
          .sort((left, right) => {
            const leftRemaining = Number(counts?.[left.key] || 0) - baseCounts[left.key];
            const rightRemaining = Number(counts?.[right.key] || 0) - baseCounts[right.key];
            return rightRemaining - leftRemaining || flavorOrder[left.key] - flavorOrder[right.key];
          })[0];
        if (!nextFlavor) return null;
        baseCounts[nextFlavor.key] += 1;
        remaining -= 1;
      }
      return baseCounts;
    };

    const cartPlanForSelection = (counts = selectedCounts(), pack = selectedPack) => {
      if (FLAVORS.some((flavor) => (
        flavorIsUnavailable(flavor.key) && Number(counts?.[flavor.key] || 0) > 0
      ))) return null;
      const { minimum, maximum } = limits(pack);
      const total = selectedTotal(counts);
      if (!counts || total < minimum || total > maximum || (pack !== 3 && total !== pack)) return null;

      const baseCounts = baseCountsForSelection(counts, pack);
      if (!baseCounts) return null;
      const basePack = pack === 3 ? THREE_PLUS_MINIMUM : pack;
      const baseVariant = variantsByMix.get(`${basePack}:${mixForCounts(baseCounts)}`) || null;
      const items = baseVariant ? [{ variant: baseVariant, quantity: 1, role: 'base' }] : [];
      const missingAddOns = [];
      const invalidAddOnPrices = [];

      if (pack === 3) {
        FLAVORS.forEach((flavor) => {
          const quantity = Number(counts[flavor.key] || 0) - Number(baseCounts[flavor.key] || 0);
          if (quantity <= 0) return;
          const variant = addOnVariantsByFlavor.get(flavor.key);
          if (!variant) {
            missingAddOns.push(flavor.key);
            return;
          }
          if (Number(variant.price) !== ADD_ON_PRICE_CENTS) {
            invalidAddOnPrices.push(flavor.key);
            return;
          }
          items.push({ variant, quantity, role: 'add-on', flavor });
        });
      }

      const complete = Boolean(baseVariant) && !missingAddOns.length && !invalidAddOnPrices.length;
      const unavailableItems = complete ? items.filter((item) => !item.variant.available) : [];
      return {
        baseVariant,
        items,
        total,
        complete,
        available: complete && unavailableItems.length === 0,
        missingAddOns,
        invalidAddOnPrices,
        unavailableItems
      };
    };

    const nextCountsForIncrement = (counts, flavorKey, pack = selectedPack) => {
      if (flavorIsUnavailable(flavorKey)) return null;
      const nextCounts = { ...counts };
      const { maximum } = limits(pack);
      const total = selectedTotal(counts);
      if (pack === 3) {
        if (total >= maximum) return null;
        nextCounts[flavorKey] += 1;
        return nextCounts;
      }
      if (total < maximum) {
        nextCounts[flavorKey] += 1;
        return nextCounts;
      }
      const replacedFlavor = replacementFlavor(counts, flavorKey);
      if (!replacedFlavor) return null;
      nextCounts[replacedFlavor.key] -= 1;
      nextCounts[flavorKey] += 1;
      return nextCounts;
    };

    const exactPriceForTotal = (total) => (
      CHECKOUT_TOTALS_CENTS[3] + Math.max(0, total - THREE_PLUS_MINIMUM) * ADD_ON_PRICE_CENTS
    );
    const formatTruncatedUsd = (cents) => `$${Math.floor(Number(cents) / 100).toLocaleString('en-US')}`;
    const naturalList = (items) => {
      if (items.length < 2) return items[0] || '';
      if (items.length === 2) return `${items[0]} and ${items[1]}`;
      return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
    };

    const renderPackPreview = (counts, pack) => {
      if (!packPreview || !packBottles || !packSummary || !bottleAssets.S.src) return;
      const total = selectedTotal(counts);
      const previewSize = pack === 3 ? Math.max(3, Math.min(6, total)) : pack;
      const groups = FLAVORS.flatMap((flavor) => {
        const quantity = Number(counts?.[flavor.key] || 0);
        return quantity > 0 ? [{ flavor, quantity }] : [];
      });
      const unselected = Math.max(0, previewSize - total);
      if (unselected) groups.push({ flavor: null, quantity: unselected });
      const signature = `${previewSize}:${groups.map(({ flavor, quantity }) => `${flavor?.key || '_'}${quantity}`).join('|')}`;

      if (signature !== lastPreviewSignature) {
        const fragment = document.createDocumentFragment();
        groups.forEach(({ flavor, quantity }) => {
          const slot = document.createElement('div');
          const visual = document.createElement('div');
          const label = document.createElement('span');
          slot.className = 'hr-spirit-pack-preview__bottle';
          slot.dataset.flavor = flavor?.key || 'empty';
          slot.dataset.quantity = String(quantity);
          visual.className = 'hr-spirit-pack-preview__visual';
          visual.style.setProperty('--hr-stack-marker-offset', `${((quantity - 1) / 2) * 22 - 3}px`);
          visual.style.setProperty('--hr-stack-marker-offset-mobile', `${((quantity - 1) / 2) * 18 - 3}px`);
          label.className = 'hr-spirit-pack-preview__bottle-name';

          for (let bottleIndex = 0; bottleIndex < quantity; bottleIndex += 1) {
            const bottle = document.createElement('img');
            const asset = flavor ? bottleAssets[flavor.key] : bottleAssets.S;
            const centeredIndex = bottleIndex - ((quantity - 1) / 2);
            bottle.className = `hr-spirit-pack-preview__image ${flavor ? 'hr-spirit-pack-preview__image--real' : 'hr-spirit-pack-preview__image--empty'}`;
            bottle.src = asset.src;
            bottle.alt = '';
            bottle.width = asset.width;
            bottle.height = asset.height;
            bottle.decoding = 'async';
            bottle.draggable = false;
            bottle.style.setProperty('--hr-stack-offset', `${centeredIndex * 22}px`);
            bottle.style.setProperty('--hr-stack-offset-mobile', `${centeredIndex * 18}px`);
            bottle.style.zIndex = String(bottleIndex + 1);
            visual.appendChild(bottle);
          }

          const labelText = document.createElement('span');
          labelText.textContent = flavor?.name || 'Choose flavor';
          label.appendChild(labelText);
          if (quantity > 1) {
            const count = document.createElement('span');
            count.className = 'hr-spirit-pack-preview__bottle-count';
            count.textContent = `×${quantity}`;
            label.appendChild(count);
          }

          if (flavor) {
            const sourceSwatch = mixPanel.querySelector(
              `[data-hr-flavor-row="${flavor.key}"] .hr-spirit-mix-match__swatch`
            );
            if (sourceSwatch) {
              const marker = document.createElement('span');
              const markerImage = sourceSwatch.cloneNode(true);
              marker.className = 'hr-spirit-pack-preview__marker';
              markerImage.setAttribute('aria-hidden', 'true');
              marker.appendChild(markerImage);
              visual.appendChild(marker);
            }
          }
          slot.append(visual, label);
          fragment.appendChild(slot);
        });
        packBottles.replaceChildren(fragment);
        lastPreviewSignature = signature;
      }

      packPreview.dataset.packSize = String(previewSize);
      packPreview.dataset.flavorGroups = String(groups.length);
      const descriptions = FLAVORS.flatMap((flavor) => {
        const quantity = Number(counts?.[flavor.key] || 0);
        if (!quantity) return [];
        return [quantity > 1 ? `${flavor.name} ×${quantity}` : flavor.name];
      });
      packSummary.textContent = `Your pack: ${naturalList(descriptions) || 'no flavors selected'}.`;
    };

    const clearCartError = () => {
      cartError = '';
      errorOutput.textContent = '';
      errorOutput.hidden = true;
      root.removeAttribute('data-hr-cart-error');
      atc.removeAttribute('title');
    };

    const setBusy = (loading) => {
      busy = loading;
      atc.dataset.hrLoading = String(loading);
      atc.setAttribute('aria-busy', String(loading));
      atcLabel.hidden = loading;
      atcLoading.hidden = !loading;
      atcLoading.setAttribute('aria-hidden', String(!loading));
    };
    const waitForLoadingPaint = () => new Promise((resolve) => {
      if (document.visibilityState === 'hidden') {
        window.setTimeout(resolve, 0);
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    const render = () => {
      const counts = selectedCounts();
      const total = selectedTotal(counts);
      const { minimum, maximum } = limits();
      const remaining = Math.max(0, minimum - total);
      const plan = cartPlanForSelection(counts);
      const selectedOffer = offers.find((offer) => Number(offer.dataset.hrCampaignOffer) === selectedPack);

      offers.forEach((offer) => {
        const pack = Number(offer.dataset.hrCampaignOffer);
        const selected = pack === selectedPack;
        const hasVariants = EXPECTED_MIXES[pack].every((mix) => variantsByMix.has(`${pack}:${mix}`)) &&
          (pack !== 3 || addOnMapComplete);
        offer.classList.toggle('is-selected', selected);
        offer.setAttribute('aria-checked', String(selected));
        offer.setAttribute('aria-expanded', String(selected));
        offer.setAttribute('aria-disabled', String(busy || !hasVariants));
        offer.tabIndex = selected ? 0 : -1;
        if (selected) offer.setAttribute('aria-controls', mixPanel.id);
        else offer.removeAttribute('aria-controls');
      });

      if (selectedOffer?.nextElementSibling !== mixPanel) selectedOffer?.after(mixPanel);
      mixPanel.hidden = false;
      mixPanel.dataset.packSize = selectedPack === 3 ? '3+' : String(selectedPack);
      mixPanel.dataset.selectedMix = mixForCounts(counts);
      mixPanel.dataset.resolvedSku = plan?.baseVariant?.sku || '';
      mixPanel.dataset.resolvedVariantId = plan?.baseVariant?.id ? String(plan.baseVariant.id) : '';
      mixPanel.dataset.resolvedAddOnSkus = plan?.items
        ?.filter((item) => item.role === 'add-on')
        .map((item) => `${item.variant.sku}:${item.quantity}`)
        .join(',') || '';
      root.dataset.hrSelectedPack = selectedPack === 3 ? '3+' : String(selectedPack);
      variantInput.value = plan?.baseVariant?.id || '';

      const status = mixPanel.querySelector('[data-hr-mix-status]');
      if (status) status.textContent = selectedPack === 3
        ? `${total} selected · max ${maximum}`
        : `${total} of ${selectedPack} selected`;
      renderPackPreview(counts, selectedPack);

      if (selectedPack === 3) {
        const offer = offers.find((candidate) => candidate.dataset.hrCampaignOffer === '3');
        const priceCents = exactPriceForTotal(total);
        const compareCents = COMPARE_PRICE_PER_BOTTLE_CENTS * total;
        const dosage = THC_PER_BOTTLE_MG * total;
        const centsPerMg = priceCents / dosage;
        offer.querySelector('[data-hr-three-plus-meta]').textContent = `${dosage.toLocaleString('en-US')}MG THC · ${centsPerMg.toFixed(1)}¢ / MG`;
        offer.querySelector('[data-hr-offer-price]').textContent = formatTruncatedUsd(priceCents);
        offer.querySelector('[data-hr-offer-compare]').textContent = formatTruncatedUsd(compareCents);
        offer.querySelector('[data-hr-offer-savings]').textContent = `Save $${SAVINGS_DOLLARS[total]}`;
      }

      FLAVORS.forEach((flavor) => {
        const quantity = Number(counts[flavor.key] || 0);
        const flavorUnavailable = flavorIsUnavailable(flavor.key);
        const row = mixPanel.querySelector(`[data-hr-flavor-row="${flavor.key}"]`);
        const counter = mixPanel.querySelector(`[data-hr-flavor-counter="${flavor.key}"]`);
        const output = mixPanel.querySelector(`[data-hr-flavor-quantity="${flavor.key}"]`);
        const unavailableLabel = row?.querySelector('[data-hr-flavor-unavailable]');
        const decrement = mixPanel.querySelector(`[data-hr-flavor-action="decrement"][data-hr-flavor="${flavor.key}"]`);
        const increment = mixPanel.querySelector(`[data-hr-flavor-action="increment"][data-hr-flavor="${flavor.key}"]`);
        const replacedFlavor = replacementFlavor(counts, flavor.key);
        const incrementCounts = nextCountsForIncrement(counts, flavor.key);
        const incrementPlan = selectedPack === 3 && incrementCounts
          ? cartPlanForSelection(incrementCounts)
          : null;
        const incrementUnavailable = selectedPack === 3 && incrementCounts &&
          (!incrementPlan?.complete || !incrementPlan.available);

        if (row) {
          row.dataset.selected = String(quantity > 0);
          row.dataset.unavailable = String(flavorUnavailable);
        }
        if (unavailableLabel) unavailableLabel.hidden = !flavorUnavailable;
        if (counter) counter.setAttribute(
          'aria-label',
          `${flavor.name} quantity: ${quantity}${flavorUnavailable ? ', sold out' : ''}`
        );
        if (output) output.textContent = String(quantity);
        if (decrement) {
          const atMinimum = selectedPack === 3 && total <= minimum;
          decrement.disabled = flavorUnavailable || quantity === 0 || busy || atMinimum;
          decrement.setAttribute('aria-disabled', String(decrement.disabled));
          decrement.setAttribute('aria-label', flavorUnavailable
            ? `${flavor.name} is sold out`
            : (atMinimum
              ? `Minimum ${minimum} bottles selected`
              : `Remove one ${flavor.name} bottle`));
          decrement.title = flavorUnavailable ? 'Sold out' : (atMinimum ? `Minimum ${minimum} bottles` : '');
        }
        if (increment) {
          increment.disabled = flavorUnavailable || busy || !incrementCounts || incrementUnavailable;
          increment.setAttribute('aria-disabled', String(increment.disabled));
          let label = `Add one ${flavor.name} bottle`;
          if (flavorUnavailable) label = `${flavor.name} is sold out`;
          else if (selectedPack === 3 && total >= maximum) label = `Maximum ${maximum} bottles selected`;
          else if (incrementUnavailable) label = `Additional ${flavor.name} bottle unavailable`;
          else if (selectedPack !== 3 && total >= selectedPack && replacedFlavor) {
            label = `Replace one ${replacedFlavor.name} bottle with ${flavor.name}`;
          }
          increment.setAttribute('aria-label', label);
          increment.title = flavorUnavailable
            ? 'Sold out'
            : (selectedPack === 3 && total >= maximum ? `Maximum ${maximum} bottles` : '');
        }
      });

      let message = '';
      if (cartError) message = cartError;
      else if (!variantMapComplete) message = 'This offer is temporarily unavailable.';
      else if (selectedPack === 3 && !addOnMapComplete) message = 'Additional bottles are temporarily unavailable.';
      else if (remaining) message = `Choose ${remaining} more ${remaining === 1 ? 'bottle' : 'bottles'} to complete your pack.`;
      else if (!plan?.complete) message = 'This flavor combination is unavailable.';
      else if (!plan.available) message = 'This flavor combination is currently sold out.';
      else if (selectedPack === 3 && total < maximum) message = 'Add more bottles for just $89.99 ea.';
      else if (selectedPack === 3) message = `Maximum of ${maximum} bottles selected.`;

      if (mixMessage) {
        mixMessage.textContent = message;
        mixMessage.hidden = !message;
        mixMessage.dataset.type = cartError ? 'error' : 'status';
        if (cartError) mixMessage.setAttribute('role', 'alert');
        else mixMessage.removeAttribute('role');
      }

      const canAdd = variantMapComplete &&
        (selectedPack !== 3 || addOnMapComplete) &&
        !busy && !remaining && Boolean(plan?.complete && plan.available);
      atc.disabled = !canAdd;
      atc.setAttribute('aria-disabled', String(!canAdd));

      let buttonText;
      if (remaining) buttonText = `Choose ${remaining} More`;
      else if (!plan?.available) buttonText = 'Combination Unavailable';
      else {
        const priceCents = selectedPack === 3 ? exactPriceForTotal(total) : CHECKOUT_TOTALS_CENTS[selectedPack];
        buttonText = `Add ${total} ${total === 1 ? 'Bottle' : 'Bottles'} — ${formatTruncatedUsd(priceCents)}`;
      }
      atcLabel.textContent = buttonText;
      return plan;
    };

    const selectOffer = (pack, shouldFocus = false) => {
      const nextOffer = offers.find((offer) => Number(offer.dataset.hrCampaignOffer) === Number(pack));
      if (!nextOffer || nextOffer.getAttribute('aria-disabled') === 'true' || busy) return;
      clearCartError();
      selectedPack = Number(pack);
      render();
      if (shouldFocus) nextOffer.focus();
    };

    offers.forEach((offer, offerIndex) => {
      offer.addEventListener('click', () => selectOffer(offer.dataset.hrCampaignOffer));
      offer.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const enabled = offers.filter((candidate) => candidate.getAttribute('aria-disabled') !== 'true');
        if (!enabled.length) return;
        let target;
        if (event.key === 'Home') target = enabled[0];
        else if (event.key === 'End') target = enabled[enabled.length - 1];
        else {
          const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
          const currentEnabledIndex = Math.max(0, enabled.indexOf(offers[offerIndex]));
          target = enabled[(currentEnabledIndex + direction + enabled.length) % enabled.length];
        }
        selectOffer(target.dataset.hrCampaignOffer, true);
      });
    });

    mixPanel.addEventListener('click', (event) => {
      if (busy) return;
      const control = event.target instanceof Element ? event.target.closest('[data-hr-flavor-action]') : null;
      if (!control || control.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      const flavorKey = control.dataset.hrFlavor;
      const counts = selectedCounts();
      if (!hasOwn(counts, flavorKey)) return;
      if (flavorIsUnavailable(flavorKey)) return;

      if (control.dataset.hrFlavorAction === 'decrement' && counts[flavorKey] > 0 &&
        (selectedPack !== 3 || selectedTotal(counts) > THREE_PLUS_MINIMUM)) {
        counts[flavorKey] -= 1;
      }
      if (control.dataset.hrFlavorAction === 'increment') {
        const nextCounts = nextCountsForIncrement(counts, flavorKey);
        if (nextCounts) FLAVORS.forEach((flavor) => { counts[flavor.key] = nextCounts[flavor.key]; });
      }
      clearCartError();
      render();
    });

    const cartDrawerPayload = () => ({
      sections: CART_DRAWER_SECTION_IDS,
      sections_url: `${window.location.pathname}${window.location.search}`
    });
    const parseResponse = async (response, fallbackMessage) => {
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (_error) {
        throw new Error(`Shopify returned an unexpected ${response.status} response.`);
      }
      if (!response.ok || data?.status) throw new Error(data?.description || data?.message || fallbackMessage);
      return data;
    };
    const postJson = async (url, body, fallbackMessage) => {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
      return parseResponse(response, fallbackMessage);
    };
    const getCart = async () => {
      const response = await fetch(config.routes.cart, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      return parseResponse(response, 'Unable to verify your cart. Please try again.');
    };
    const cartIsEmpty = (cart) => Number(cart?.item_count || 0) === 0 &&
      (!Array.isArray(cart?.items) || cart.items.length === 0);
    const resetCart = async () => {
      let clearedCart = await postJson(
        config.routes.clear,
        {},
        'Unable to clear your cart. Please try again.'
      );

      if (!cartIsEmpty(clearedCart) && Array.isArray(clearedCart?.items)) {
        const updates = clearedCart.items.reduce((result, item) => {
          if (item?.key) result[item.key] = 0;
          return result;
        }, {});
        if (Object.keys(updates).length) {
          clearedCart = await postJson(
            config.routes.update,
            { updates },
            'Unable to clear your cart. Please try again.'
          );
        }
      }

      if (!cartIsEmpty(clearedCart)) {
        throw new Error('Your cart could not be cleared. Please try again.');
      }

      const preparedCart = await postJson(
        config.routes.update,
        { discount: '' },
        'Unable to prepare this offer. Please try again.'
      );
      if (!cartIsEmpty(preparedCart)) {
        throw new Error('Your cart could not be cleared. Please try again.');
      }
      return preparedCart;
    };
    const applyDiscount = async (pack) => {
      if (!config.applyBundleDiscounts) return getCart();
      const code = config.discountCodes?.[String(pack)];
      if (!code) throw new Error('This offer is temporarily unavailable. Please try again later.');
      return postJson(
        config.routes.update,
        { discount: code, ...cartDrawerPayload() },
        'Unable to apply this offer. Please try again.'
      );
    };
    const expectedTotal = (pack, plan) => {
      if (!config.applyBundleDiscounts) {
        return plan.items.reduce(
          (total, item) => total + Number(item.variant.price || 0) * Number(item.quantity || 0),
          0
        );
      }
      if (pack === 1 || pack === 2) return CHECKOUT_TOTALS_CENTS[pack];
      return exactPriceForTotal(plan.total);
    };
    const validateCart = (cart, plan, expectedPrice) => {
      const expectedQuantities = new Map();
      plan.items.forEach((item) => {
        const id = Number(item.variant.id);
        expectedQuantities.set(id, (expectedQuantities.get(id) || 0) + Number(item.quantity || 0));
      });
      const actualQuantities = new Map();
      cart.items?.forEach((item) => {
        const id = Number(item.variant_id || item.id);
        actualQuantities.set(id, (actualQuantities.get(id) || 0) + Number(item.quantity || 0));
      });
      const quantitiesMatch = expectedQuantities.size === actualQuantities.size &&
        [...expectedQuantities].every(([id, quantity]) => actualQuantities.get(id) === quantity);
      if (!quantitiesMatch) throw new Error('Your bottle selection could not be verified.');

      const addOnIds = new Set(
        plan.items.filter((item) => item.role === 'add-on').map((item) => Number(item.variant.id))
      );
      if (addOnIds.size) {
        const baseLine = cart.items?.find((item) => Number(item.variant_id || item.id) === Number(plan.baseVariant.id));
        const nestedLines = cart.items?.filter((item) => addOnIds.has(Number(item.variant_id || item.id))) || [];
        const relationshipsMatch = Boolean(baseLine?.key) && nestedLines.length === addOnIds.size &&
          nestedLines.every((item) => item.parent_relationship?.parent_key === baseLine.key);
        if (!relationshipsMatch) throw new Error('Your additional bottles could not be linked to this offer.');
      }
      if (Number(cart.total_price) !== Number(expectedPrice)) {
        throw new Error(CART_PRICE_VERIFICATION_ERROR);
      }
    };

    const applyAndConfirmDiscount = async (pack, plan, expectedPrice) => {
      if (!config.applyBundleDiscounts) {
        const cart = await applyDiscount(pack);
        validateCart(cart, plan, expectedPrice);
        return cart;
      }

      let priceError = null;
      for (const delayMs of CART_CONFIRMATION_DELAYS_MS) {
        await applyDiscount(pack);
        await new Promise((resolve) => window.setTimeout(resolve, delayMs));
        const cart = await getCart();
        try {
          validateCart(cart, plan, expectedPrice);
          return cart;
        } catch (error) {
          if (error?.message !== CART_PRICE_VERIFICATION_ERROR) throw error;
          priceError = error;
        }
      }
      throw priceError || new Error(CART_PRICE_VERIFICATION_ERROR);
    };

    const visible = (element) => {
      if (!element) return false;
      const style = window.getComputedStyle(element);
      const bounds = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' &&
        bounds.width > 0 && bounds.height > 0 && bounds.right > 0 && bounds.bottom > 0 &&
        bounds.left < window.innerWidth && bounds.top < window.innerHeight;
    };
    const eliteCartOpen = () => {
      const backdrop = document.getElementById('EliteCartBackdrop');
      const panel = document.querySelector(
        '#EliteCartContainer.ec-cart-container, #EliteCartContainer .ec-cart-container, [role="dialog"].ec-cart-container, [role="dialog"] .ec-cart-container'
      );
      return visible(backdrop) || visible(panel);
    };
    const openEliteCart = async () => {
      let refreshRequested = false;
      const deadline = Date.now() + 2500;

      while (Date.now() < deadline) {
        if (eliteCartOpen()) return true;
        const open = window.EliteCart?.openDrawerWithDataRefresh;
        if (!refreshRequested && typeof open === 'function') {
          refreshRequested = true;
          try {
            await open.call(window.EliteCart);
            return true;
          } catch (error) {
            console.warn('High Rider: EliteCart could not be opened.', error);
            return false;
          }
        }
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }
      return eliteCartOpen();
    };
    const requestDrawerSections = async () => {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('sections', CART_DRAWER_SECTION_IDS.join(','));
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      return parseResponse(response, 'Unable to load the cart drawer.');
    };
    const openNativeDrawer = async (cart) => {
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.renderContents !== 'function') return false;
      let sections = cart?.sections;
      if (!sections || CART_DRAWER_SECTION_IDS.some((sectionId) => !sections[sectionId])) {
        sections = await requestDrawerSections();
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents({
        ...cart,
        id: cart?.items?.[0]?.product_id || config.productId,
        sections
      });
      return true;
    };
    const openCart = async (cart) => (await openEliteCart()) || openNativeDrawer(cart);

    const showCartError = (message) => {
      cartError = message;
      root.dataset.hrCartError = message;
      errorOutput.textContent = message;
      errorOutput.hidden = false;
      atc.title = message;
    };

    const addToCart = async () => {
      const pack = selectedPack;
      const counts = { ...selectedCounts() };
      const plan = cartPlanForSelection(counts, pack);
      if (busy || !plan?.complete || !plan.available || atc.getAttribute('aria-disabled') === 'true') return;

      const items = plan.items.map((item) => {
        const cartItem = { id: Number(item.variant.id), quantity: Number(item.quantity) };
        if (item.role === 'add-on') cartItem.parent_id = Number(plan.baseVariant.id);
        return cartItem;
      });
      let cartPrepared = false;
      clearCartError();
      setBusy(true);
      render();

      try {
        await waitForLoadingPaint();
        const requiredTotal = expectedTotal(pack, plan);
        await resetCart();
        cartPrepared = true;
        await postJson(config.routes.add, { items }, 'Unable to add this bottle selection.');
        const cart = await applyAndConfirmDiscount(pack, plan, requiredTotal);

        document.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          detail: {
            productId: config.productId,
            variantId: plan.baseVariant.id,
            variantIds: items.map((item) => item.id),
            items,
            cartData: cart,
            source: 'spirit-list1-campaign-buybox'
          }
        }));

        try {
          if (!(await openCart(cart))) window.location.assign(config.routes.cartPage);
        } catch (drawerError) {
          console.error('High Rider: cart drawer failed.', drawerError);
          window.location.assign(config.routes.cartPage);
        }
      } catch (error) {
        let cleanupSucceeded = false;
        let cleanupFailed = false;
        if (cartPrepared) {
          try {
            await resetCart();
            cleanupSucceeded = true;
          } catch (cleanupError) {
            cleanupFailed = true;
            console.error('High Rider: cart cleanup failed.', cleanupError);
          }
        }
        console.error('High Rider: add to cart failed.', error);
        if (cleanupFailed) {
          showCartError('We could not verify this offer. Please remove any Spirit items from your cart before checkout.');
        } else {
          const baseMessage = error?.message || 'Unable to add this item.';
          showCartError(cleanupSucceeded ? `${baseMessage} Your cart was reset; please try again.` : baseMessage);
        }
      } finally {
        setBusy(false);
        render();
      }
    };

    atc.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });
    form.addEventListener('submit', (event) => event.preventDefault());

    render();
  };

  const initializeRoot = (root) => {
    if (!(root instanceof Element) || root.dataset.hrList1CampaignInitialized === 'true') return;
    const config = parseConfig(root);
    if (!config) return;
    root.dataset.hrList1CampaignInitialized = 'true';
    initializeGallery(root, config);
    initializeReviewCount(root);
    initializeCommerce(root, config);
  };

  const initializeAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) initializeRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initializeRoot);
  };

  if (window.HrSpiritList1CampaignBuybox?.initializeAll) {
    window.HrSpiritList1CampaignBuybox.initializeAll(document);
    return;
  }
  window.HrSpiritList1CampaignBuybox = { initializeAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
